import React from 'react'
import Summarize from './Summarize'

const Body = () => {
  return (
    <div className='flex flex-col justify-center items-center w-screen'>
        <Summarize/>
    </div>
    
  )
}

export default Body